import React from 'react';
import store from 'store';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Typography } from 'antd';
import { ReactComponent as FemaleThanksSvg } from '../../../assets/icons/sign-up/female-thanks.svg';
import ButtonFooter from '../../../components/mobile/ButtonFooter';
import { LOCAL_STORAGE_AUTH_KEY } from '../../../config/constants';

const { Title, Paragraph } = Typography;

const styles = {
  title: {
    fontWeight: "300",
    fontSize: "24px",
    lineHeight: "28px",
    textAlign: "center",
    color: "#15A9E1"
  },
  textBottom: {
    fontWeight: "300",
    fontSize: "18px",
    lineHeight: "28px",
    textAlign: "center",
    color: "#404047"
  }
}

function MobileThankYouScreen() {
  const { t } = useTranslation(['sign-up', 'common']);
  const history = useHistory();

  const onBack = () => {
    store.remove(LOCAL_STORAGE_AUTH_KEY.FAMILY_PROFILE_SIGNUP);
    history.push('/reason')
  }

  return (
    <>
      <Row justify="center">
        <FemaleThanksSvg />
      </Row>
      <Box marginTop={22}>
        <Title level={4} style={styles.title}>
          {t('sign-up:thankYou')}
        </Title>
      </Box>
      <Box marginTop={25}>
        <Paragraph style={styles.textBottom}>
          {t('sign-up:oneOfDoctor')}
        </Paragraph>
      </Box>
      <ButtonFooter
        title={t('sign-up:backToHome')}
        onClick={onBack}
      />
    </>
  );
}

export default MobileThankYouScreen;
